module.exports = __webpack_public_path__ + "static/media/logo_login.9201508e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_login.png
// module id = 318
// module chunks = 0